import axios from 'axios';
import { useEffect } from 'react';
import { useCmsUrlPath } from '@gov-nx/store';

const instance = axios.create({
	headers: {
		'Content-Type': 'application/json',
	},
});

const baseInstance = axios.create({
	headers: {
		'Content-Type': 'application/json',
	},
});

export const useAxiosCmsInstance = () => {
	const { cmsUrlPath, baseCmsUrlPath } = useCmsUrlPath();

	useEffect(() => {
		instance.interceptors.request.use((config) => {
			config.baseURL = cmsUrlPath;
			return config;
		});
	}, [cmsUrlPath]);

	useEffect(() => {
		baseInstance.interceptors.request.use((config) => {
			config.baseURL = baseCmsUrlPath;
			return config;
		});
	}, [baseCmsUrlPath]);

	return { axiosCmsInstance: instance, axiosCmsBaseInstance: baseInstance };
};
